import { render, staticRenderFns } from "./SuccessModalNew.vue?vue&type=template&id=10c2a787&"
import script from "./SuccessModalNew.vue?vue&type=script&lang=js&"
export * from "./SuccessModalNew.vue?vue&type=script&lang=js&"
import style0 from "./SuccessModalNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports